import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Anchor from 'components/common/Anchor/Anchor'
import Carousel from 'components/common/Carousel'
import { LazyDiv } from 'components/common/LazyHtml'
import { ABOUT_BRAND_SECTION_ID } from '../constants'
import { CAROUSEL_CONFIG } from './constants'
import MichelinPromisePlan from './../assets/MichelinPromisePlan-transparent.svg'

const BrandDetailAndMarketingSpotligh = ({ description, title, placeholders: { brandMarketingContent = []} = {}}) =>
  <Wrapper data-at-brand-detail>
    <Anchor id={ ABOUT_BRAND_SECTION_ID } top="-216" />
    <Content>
      <Title data-at-title>{ title }</Title>
      <Description content={ description } data-at-description />
      {
        brandMarketingContent.length > 0 &&
          <CustomCarousel config={ CAROUSEL_CONFIG } >
            { brandMarketingContent }
          </CustomCarousel>
      }
    </Content>
  </Wrapper>

export default BrandDetailAndMarketingSpotligh

BrandDetailAndMarketingSpotligh.propTypes = {
  description: PropTypes.string,
  placeholders: PropTypes.shape({
    brandMarketingContent: PropTypes.arrayOf()
  }),
  title: PropTypes.string
}

const Wrapper = styled.div`
  margin-bottom: 34px;
  padding: 35px 0 42px;
  color: ${Theme.colors.white};
  background-color: ${Theme.colors.dark_grey};
  ${Media.desktop`
    margin-bottom: 55px;
    padding: 56px 0 53px;
  `}
`

const Content = styled.div`
  max-width: 648px;
  margin: 0 auto;
  ${Media.mobile`
    padding: 0 16px;
  `}

  a {
    color: ${Theme.colors.white};
    font-weight: 700;
  }
`

const Title = styled.div`
  text-transform: uppercase;
  ${Mixin.font.GothamBold(26, 600)}
  ${Media.mobile`
    font-size: 20px;
  `}
`

const Description = styled(LazyDiv)`
  margin-top: 5px;
  line-height: 1.5;

  .michelin-promise-plan-logo {
    background-image: url(${MichelinPromisePlan});
  }
`

const CustomCarousel = styled(Carousel)`
  margin-top: 43px;
  padding-bottom: 36px;

  .slick-slide {
    text-align: center;
  }

  .slick-dots {
    bottom: -36px;
    left: 50%;
    transform: translateX(-50%);

    li {
      width: 12px;
      height: 12px;
    }
  }
`
